import rootApi from '@utils/baseAPI/WrapperApi';

export const apiGetAllUser = (data) => {
  return rootApi.get('api/v1/drm/order', { params: data });
};
export const apiAddUserOperator = (data) => rootApi.post('/api/user', data);
export const apiGetUserDetail = (id) => rootApi.get(`/api/user/${id}`);
export const apiUpdateUser = (id, data) => rootApi.put(`/api/user/${id}`, data);
export const apiUpdateRoleUserOperator = (id, data) =>
  rootApi.post(`admin/users/change-role/${id}`, data);
export const apiDeleteUserOperator = (id) =>
  rootApi.delete(`admin/users/remove-operator-user/${id}`);

export const apiUpdateFCMToken = (data) => rootApi.post('/api/user/update/fcm-token', data);

export const apiEnableUser = (id) => rootApi.put(`/api/user/${id}/enable`);
export const apiDisableUser = (id) => rootApi.put(`/api/user/${id}/disable`);
export const apiSoftDeleteUser = (id) => rootApi.delete(`/api/user/${id}/soft-delete`);
